import React, { memo, useEffect, useState } from 'react'
import map from 'ramda/src/map'
import splitEvery from 'ramda/src/splitEvery'
import length from 'ramda/src/length'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import { colorsNew, ltGtMediaQuery } from 'root/src/client/web/commonStyles'
import ANCHORS from 'root/src/shared/constants/anchors'
import Accordion from './Accordion'

const styles = {
	root: {
		background: colorsNew.dark2,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		margin: [[10, 'auto']],
		padding: [[50, 50, 100]],
		borderRadius: 40,
		[ltGtMediaQuery]: {
			padding: [[50, 0]],
			width: '95%',
		},
	},
	label: {
		margin: 25,
		textAlign: 'center',
		color: colorsNew.light1,
	},
	accordions: {
		display: 'flex',
		[ltGtMediaQuery]: {
			flexDirection: 'column',
			alignItems: 'center',
		},
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		margin: [[0, 15]],
	},
}

const useFAQSection = () => {
	const [accordionIdHash, setAccordionIdHash] = useState('')

	useEffect(() => {
		if (window) {
			setAccordionIdHash(window.location.hash.slice(1))
		}
	}, [])
	return {
		accordionIdHash,
	}
}

const FAQSection = memo(({
	classes, pageContent,
}) => {
	const { items } = pageContent
	const { accordionIdHash } = useFAQSection()

	return (
		<div
			className={classes.root}
			id={ANCHORS.DROP_FAQ_SECTION}
		>
			<Typography
				variant={typographyVariants.heading2}
			>
				FAQs
			</Typography>
			<Typography
				variant={typographyVariants.paragraph}
				className={classes.label}
			>
				Find quick answers to your most pressing questions. Or, contact us.
			</Typography>
			<div className={classes.accordions}>
				{map(column => (
					<div className={classes.column} key={column[0].title}>
						{map(({ id, title, content }) => (
							<Accordion
								id={id}
								isActive={accordionIdHash === id}
								title={title}
								content={content}
								key={title}
							/>
						), column)}
					</div>
				), splitEvery(length(items) / 2)(items))}
			</div>
		</div>
	)
})

export default withStyles(styles, { name: 'MuiFaqSection' })(FAQSection)
